import { Tooltip, theme } from 'antd';
import type { StatusTone } from './statusTone';

interface StatusDotProps {
  /** Tooltip text, e.g. "Status moderacji: Aktywny". */
  title: string;
  tone: StatusTone;
}

/** Bare `●` for dense tables — the label lives only in the tooltip.
 * `StatusDotTag` is the sibling that keeps the label visible. */
export const StatusDot = ({ title, tone }: StatusDotProps) => {
  const { token } = theme.useToken();
  const color = {
    success: token.colorSuccess,
    warning: token.colorWarning,
    error: token.colorError,
  }[tone];

  return (
    <Tooltip title={title}>
      <span
        role="img"
        aria-label={title}
        style={{
          color,
          fontSize: token.fontSizeSM,
          lineHeight: 1,
          cursor: 'default',
        }}
      >
        ●
      </span>
    </Tooltip>
  );
};
